import { Box, Grid } from '@mui/material';
import { GridToolbarContainer, GridToolbarQuickFilter } from '@mui/x-data-grid';
import { useLowResolution } from 'hooks';
import React from 'react';
import { IDataGridProps } from 'types/common';

const DataGridToolbar: React.FC<IDataGridProps> = ({
	actions,
	leftActions
}) => {
	const lowRes = useLowResolution();

	const filterComp = (
		<GridToolbarQuickFilter
			label={intl.tr('actions.search')}
			variant="outlined"
			size="small"
			placeholder=""
			data-testid="data-grid-toolbar-quick-filter"
			inputMode="search"
			sx={{
				svg: {
					opacity: '0.6'
				}
			}}
		/>
	);

	let barComp;
	if (lowRes) {
		barComp = (
			<Grid container spacing={1}>
				<Grid item xs={12} sm={4}>
					{filterComp}
				</Grid>
				<Grid item xs={12} sm={4}>
					{leftActions}
				</Grid>
				<Grid item xs={12} sm={4}>
					{actions}
				</Grid>
			</Grid>
		);
	} else {
		barComp = (
			<>
				<Box display="flex" flexGrow={1}>
					{filterComp}
					<Box display="flex" flexGrow={1} pl={3}>
						{leftActions}
					</Box>
				</Box>
				<Box display="flex" flexGrow={1} flexDirection="row-reverse">
					{actions}
				</Box>
			</>
		);
	}

	return <GridToolbarContainer>{barComp}</GridToolbarContainer>;
};

export default DataGridToolbar;
